module.exports = __webpack_public_path__ + "img/properties-template.c639b972.svg";